import { useCallback, useState } from "react";

/**
 * useScrollLockOnSelect
 *
 * A custom hook that locks the page scroll when a Select dropdown is open,
 * and restores scrolling when it closes. It also compensates for scrollbar
 * width to prevent layout shifts (screen jump).
 *
 * 📦 Usage:
 * const { handleOpen, handleClose } = useScrollLockOnSelect();
 * <Select onOpen={handleOpen} onClose={handleClose} ... />
 *
 * @returns {Object} Handlers to be used on Select's `onOpen` and `onClose`
 */
export const useScrollLockOnSelect = () => {
  const [scrollY, setScrollY] = useState(0);

  const handleOpen = useCallback(() => {
    const currentScrollY = window.scrollY;
    setScrollY(currentScrollY);
    document.body.style.position = "fixed";
    document.body.style.top = `-${currentScrollY}px`;
    document.body.style.width = "100%";
  }, []);

  const handleClose = useCallback(() => {
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";
    window.scrollTo({ top: scrollY });
  }, [scrollY]);

  return { handleOpen, handleClose };
};
